import { all, takeLatest, takeEvery } from 'redux-saga/effects'
import {
  addAddress,
  changeTimeSlotStatus,
  confirmSalesOrder,
  generateSalesOrder, getUserBookedShift,
  updateSalesOrder
} from 'redux/slices/nurseCampaignSlice'
import {updateCamapignOrder} from 'redux/slices/nurseCampaignSlice'
import {assignCampaignJobToNurse} from 'redux/slices/nurseCampaignSlice'
import {getCampaignInfo} from 'redux/slices/nurseCampaignSlice'
import {
  getActiveNurses,
  getCampaigns,
  cancelBookings,
  getShifts,
  getBookings,
  getUserInfo,
  bookCampaigns,
} from 'redux/slices/nurseCampaignSlice'
import {
  handleActiveNursesGet,
  handleBookingCancel,
  handleBookingsGet,
  handleCampaignsGet,
  handleGetShifts,
  handleUserInfoGet,
  handleCampaignBookings,
  handleCampaignInfoGet,
  handleChangeTimeSlotStatus,
  handleAssignCampaingToNurse,
  handleUpdateOrder,
  handleAddAddress,
  handleGenerateSaleOrder,
  handleUpdateSalesOrder,
  handleConfirmSalesOrder,
  handleGetUserBookedShift,
} from './handlers/nurseCampaignHandler'

const nurseCampaignSaga = [
  takeLatest(getCampaigns.type, handleCampaignsGet),
  takeLatest(getActiveNurses.type, handleActiveNursesGet),
  takeLatest(getBookings.type, handleBookingsGet),
  takeLatest(cancelBookings.type, handleBookingCancel),
  takeLatest(getShifts.type, handleGetShifts),
  takeLatest(getUserInfo.type, handleUserInfoGet),
  takeLatest(bookCampaigns.type, handleCampaignBookings),
  takeLatest(getCampaignInfo.type, handleCampaignInfoGet),
  takeLatest(changeTimeSlotStatus.type, handleChangeTimeSlotStatus),
  takeLatest(assignCampaignJobToNurse.type, handleAssignCampaingToNurse),
  takeLatest(updateCamapignOrder.type, handleUpdateOrder),
  takeLatest(addAddress.type, handleAddAddress),
  takeLatest(generateSalesOrder.type , handleGenerateSaleOrder),
  takeLatest(updateSalesOrder.type, handleUpdateSalesOrder),
  takeLatest(confirmSalesOrder.type, handleConfirmSalesOrder),
  takeLatest(getUserBookedShift.type, handleGetUserBookedShift),
]

export default nurseCampaignSaga
